import { render, staticRenderFns } from "./orderStatementInvoicesBox.vue?vue&type=template&id=43b523d3&"
import script from "./orderStatementInvoicesBox.vue?vue&type=script&lang=ts&"
export * from "./orderStatementInvoicesBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports